import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { PLAYROOM_REWARDS_SECTION_PAGE_KEY } from "../constants";
var PTTranslations = /*#__PURE__*/_defineProperty({}, PLAYROOM_REWARDS_SECTION_PAGE_KEY, {
  PRS_TAB_MARKETPLACE: 'Catálogo',
  PRS_TAB_HISTORY: 'História',
  PRS_STATUS_DELIVERED: 'Entregue em',
  PRS_STATUS_REQUESTED: 'Solicitado',
  PRS_ORDER_NUMBER: 'Ordem n.º {{order}}',
  PRS_CTA_REWARD_TITLE: 'Seleccionou este item',
  PRS_CTA_REWARD_CANCEL: 'Cancelar',
  PRS_CTA_REWARD_SOLICIT: 'Solicitar',
  PRS_SECTION_MARKETPLACE_DESCRIPTION: 'Descubra as recompensas que pode resgatar pelos seus esforços durante as suas actividades de aprendizagem.',
  PRS_EXCHANGE_FAILED_TITLE: '¡Solicitud de canje fallida!',
  PRS_EXCHANGE_FAILED_DESCRIPTION: 'Ha ocurrido un error, por favor inténtelo de nuevo más tarde',
  PRS_EXCHANGE_FAILED_OK: 'Listo',
  PRS_SECTION_MARKETPLACE_REDEEMING: 'Solicitando',
  PRS_X_CREHANACOINS: '{{coins}} {{currencyName}}',
  PRS_MISSING_CREHANACOINS: 'Faltam *{{coins}} {{currencyName}}* para resgatar esta recompensa',
  PRS_LIMIT_REMDEPTIONS_1: 'Você tem',
  PRS_LIMIT_REMDEPTIONS_2: 'pedidos disponíveis para esta recompensa',
  PRS_WITHOUT_LIMITS: 'Você pode solicitar esta recompensa sem limites',
  PRS_LIMIT_REARCH_REDEMPTIONS: 'Você atingiu o limite disponível desta recompensa',
  PRS_ACCEPT_TERMS_1: 'Aceito o',
  PRS_ACCEPT_TERMS_2: 'termos e condições',
  PRS_EXCHANGE_SUCCESFUL_TITLE: 'Pedido de intercâmbio bem sucedido!',
  PRS_EXCHANGE_SUCCESFUL_DESCRIPTION: 'Seu administrador entrará em contato com você para coordenar o recebimento de sua recompensa.',
  PRS_EXCHANGE_SUCCESFUL_OK: 'Compreendido',
  PRS_CTA_EXCHANGE: 'Redimir',
  PRS_CTA_SEE_DETAIL: 'Ver detalhe',
  PRS_HISTORY_SECTION_DESCRIPTION: 'Tu historial de compras',
  PRS_EMPTY_TITLE: 'Ainda não se candidatou a uma recompensa',
  PRS_EMPTY_DESCRIPTION: 'Vá ao mercado para escolher a sua recompensa',
  PRS_EMPTY_MARKETPLACE_TITLE: 'Não há recompensas disponíveis neste momento',
  PRS_AVAILABLE_COINS: 'Se você trocar esses pontos, você terá',
  PRS_AVAILABLE_STOCK: 'Falta {{count}} item',
  PRS_AVAILABLE_STOCK_plural: 'Faltam {{count}} itens'
});
export default PTTranslations;